import React, {useState} from 'react'
import {useForm} from 'react-hook-form';
import {useDispatch, useSelector} from 'react-redux';
import {openAlert} from '../../slices/alert';
import {closeDialog} from '../../slices/dialog';
import {selectName, selectUser} from '../../slices/profile';
import {selectSelectedCompany, selectSelectedRm} from '../../slices/selected';
import {addFollow} from '../../api/follow';
import {sanitizeUrl} from '../../helpers/misc';
import {analyticsEvents, ROUTES} from '../../db/models/const';
import {useHistory} from 'react-router';
import {useTranslation} from 'react-i18next';

export const FollowRmDisclaimer = () => {
    const user = useSelector(selectUser);
    const displayName = useSelector(selectName);
    const rm = useSelector(selectSelectedRm);
    const company = useSelector(selectSelectedCompany);
    const [disabled, setDisabled] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const { register, handleSubmit, errors } = useForm({
        defaultValues: {
            acceptance: false
        }
    });
    const { t } = useTranslation();

    const onLinkClick = () => {
        if (!(company?.rmTerms)) return;
        window.open(sanitizeUrl(company.rmTerms), '_blank', 'noopener');
    }

    const onSave = () => {
        if (!user || !displayName)
            return;

        setDisabled(true);
        dispatch(closeDialog());
        dispatch(openAlert({ type: "info", message: t("alert_wait") }));

        addFollow(rm.id)
            .then((res) => {
                dispatch(openAlert({ type: "success", message: t("alert_rm_created") }));
                history.push(ROUTES.FOLLOW.replace(":rmId", rm.id));
            })
            .catch(error => {
                dispatch(openAlert({ type: "error", message: t("alert_generic_error") }));
                setDisabled(false);
            });
    }

    return (
        <div className="followRmDisclaimer">
            <p className={"text-justify"}>{t("student_followDisclaimer_expl")}</p>
            <form onSubmit={handleSubmit(onSave)}>
                <div className="checkboxList">
                    <div className="checkbox first">
                        <input type="checkbox" name="acceptance" ref={register({ required: true })}></input>
                        <p>{t("student_followDisclaimer_informative") + " "}<span className="link"
                            onClick={() => onLinkClick()}>{t("student_followDisclaimer_informative_link")}</span>
                        </p>
                    </div>
                    {/* <div className="checkbox">
                        <input type="checkbox" name="agreement1" ref={register({ required: true })}></input>
                        <p>{t("student_followDisclaimer_processing")}</p>
                    </div>
                    <div className="checkbox">
                        <input type="checkbox" name="agreement2" ref={register({ required: true })}></input>
                        <p>{t("student_followDisclaimer_contact")}</p>
                    </div> */}
                    {(errors.acceptance) && <span className="error">{t("student_followDisclaimer_error")}</span>}
                </div>
                <input type="submit" value={t("student_followDisclaimer_submit")} disabled={disabled}></input>
            </form>
        </div>
    )
}
